import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {
    MvsApiCrudServiceCommentsInterface
} from '../../../../core/shared/service/api/mvs-api-crud-service-comments.interface';

/**
 * CRUD service for {@code xx.XxCarPilotBrandComment} (comment sandbox fixture, recording B).
 *
 * Implements {@link MvsApiCrudServiceCommentsInterface} so the generic {@code mvs-object-comments}
 * component's duck-typed compatibility check ({@code "getCommentAttribute" in service}) succeeds.
 * TRAP: registering {@code xx.XxCarPilotBrandComment} route-only in the entity-provider yields a
 * plain {@link MvsCrudService} from {@code MvsCoreService.getCrudService()} — one that does NOT
 * satisfy the check — and the component refuses with "The used service is not compatible!" in the
 * console, rendering silently empty. This service (plus its `service:` registry entry) is what
 * makes the fixture actually mount.
 *
 * @ticket TM-1000002003
 */
@Injectable({
    providedIn: 'root'
})
export class XxCarPilotBrandCommentService extends MvsCrudService implements MvsApiCrudServiceCommentsInterface {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/xx/xxCarPilotBrandComments');
    }

    getCommentAttribute(): string {
        return 'comment';
    }

    hasCommentPinOption(): boolean {
        return true;
    }

    override getLinkedAttribute(objectType: string): string {
        if (objectType === 'xx.XxCarPilotBrand') {
            return 'carPilotBrand';
        }
        return super.getLinkedAttribute(objectType);
    }

}
